// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1445":"f3f0dcc1","1597":"65d9e5b6","2565":"b918b21b","5568":"fe5bc534"}[chunkId] + ".chunk.css";
};